<template>
  <div>
    <div class="goods-item" :key="item.product_id">
      <div class="goods-top">
        <!-- 分类 bbd -->
        <div
          class="best-befor classify"
          v-if="
            item.goods[0].bbd ||
            (item.goods[0].goods && item.goods[0].goods.bbd)
          "
        >
          Best Before
          {{
            formBBD(
              item.goods[0].bbd ||
                (item.goods[0].goods && item.goods[0].goods.bbd)
            )
          }}
        </div>
        <!-- 临期 bbd -->
        <div
          class="best-befor"
          v-else-if="
            item.goods[0].expiration_date ||
            (item.goods[0].goods && item.goods[0].goods.expiration_date)
          "
        >
          Best Before
          {{
            formBBD(
              item.goods[0].expiration_date ||
                (item.goods[0].goods && item.goods[0].goods.expiration_date)
            )
          }}
        </div>
        <a class="goods-img" :href="`/${skipUrl}/product/${item.product_id}`">
          <el-image
            :src="
              item.background
                ? item.background +
                  '?x-oss-process=image/resize,m_lfit,h_200,w_200&d=200x200'
                : '/images/new/ins-05.png?x-oss-process=image/resize,m_lfit,h_50,w_50&d=50x50'
            "
            class="goods-image"
          >
            <div slot="error" class="image-slot"></div
          ></el-image>
          <div class="poabs" v-if="!item.isSoom">COMING SOON</div>
          <!-- 告罄图片 -->
          <!-- <img src="/images/soldout.png?x-oss-process=image/resize,m_lfit,h_120,w_50&d=120x50" v-if="!(item.num || item.goods[0].num) || (isSeckill && (!item.goods[0].goods.num || !(item.total_num - item.sale_num)))" alt="soldout" class="soldout" /> -->
        </a>
      </div>
      <div class="goods-name">{{ item.cn_name }}</div>
      <div
        class="zkFlexs"
        v-if="Number(item.price_eur) > 0 || item.external_type == 5"
      >
        <div class="offzkou" v-if="Number(item.price_eur) > 0">
          {{ couponStrength }}off
        </div>
        <div
          :class="Number(item.price_eur) > 0 ? 'offzkou mleft5' : 'offzkou'"
          v-if="item.external_type == 5"
        >
          {{ "买" + item.external.buy_num + "送" + item.external.gift_num }}
        </div>
      </div>
      <div class="spceas" v-else>
        {{ item.goods[0].spec[0].spec_value_name }}
      </div>
      <div class="goods-bottom">
        <div class="goods-price">
          <div class="fleaxbksg">
            <div class="spec-price">
              <del
                v-if="+item.goods[0].external_price && item.goods[0].type !== 3"
                v-html="
                  '€' +
                  formPrice(item.goods[0].spec_price || item.goods[0].price)
                "
              ></del>
              <div
                v-else
                v-html="'€' + formPrice(item.goods[0].spec_price)"
                class="original"
              ></div>
            </div>
            <div
              class="external-price"
              v-if="+item.goods[0].external_price && item.goods[0].type !== 3"
              v-html="'€' + formPrice(item.goods[0].external_price)"
            ></div>
            <div class="oldPrice" v-if="Number(item.price_eur)">
              €{{ item.price_eur }}
            </div>
          </div>
          <!-- 规格 -->
          <span class="spec" v-if="spec">{{ item.goods[0].spec_name }}</span>
        </div>
        <!-- <i
            class="el-icon-circle-plus add-card"
            v-if="!isSeckill"
            @click.prevent="showCart(item)"
            alt="shopping-cart"
          ></i> -->
        <img
          src="/images/newpcImg/addcart.png"
          v-if="!isSeckill"
          @click.prevent="showCart(item)"
          class="addIcon"
          alt=""
        />
      </div>
      <div v-if="isSeckill" class="progress">
        <div class="sale">
          <span>{{ $t("homeRight.sold") }} {{ percentage }}%</span>
          <el-progress
            :percentage="percentage"
            :stroke-width="10"
            color="#F13D3D"
            :show-text="false"
          ></el-progress>
        </div>
        <div
          :class="[
            'purchase',
            { gray: !(item.total_num - item.sale_num) || item.status === 1 },
          ]"
          @click.prevent="showCart(item)"
        >
          {{ $t("homeRight.buynow") }}
        </div>
      </div>
    </div>
    <cartDialog
      @dialog-visible-show="dialogVisibleShow"
      :goods-detail="goodsDetail"
      :dialog-visible="dialogVisible"
      :add-cart-loading="addCartLoading"
      @input="input"
    />
  </div>
</template>
  
  <script>
// 格式化价格
import formPrice from "./formPrice";
import cartDialog from "./CartDialog.vue";
import { store } from "../header";
export default {
  props: {
    item: Object,
    spec: Boolean,
    isSeckill: Boolean,
    isWish: Boolean,
    isFavorite: {
      type: String,
      default: "",
    },
  },
  components: {
    cartDialog,
  },
  data() {
    return {
      formPrice: formPrice,
      dialogVisible: false,
      goodsDetail: {},
      addCartLoading: false,
      is_favorite: false,
    };
  },
  created() {
    if (this.isFavorite) {
      const arr = Object.values(JSON.parse(this.isFavorite));
      if (arr.includes(this.item.product_id + "")) {
        this.is_favorite = true;
        this.item.is_favorite = true;
      }
    }
  },
  computed: {
    couponStrength() {
      const pricesa = this.item.spec_price
        ? this.item.spec_price
        : this.item.goods[0].spec_price;
      const priceStren = Number(
        (
          ((Number(this.item.price_eur) - Number(pricesa)) /
            Number(this.item.price_eur)) *
          100
        ).toFixed(0)
      );
      return priceStren > 99 ? 99 + "%" : priceStren + "%";
    },
    skipUrl() {
      return localStorage.getItem("localLang");
    },
    percentage() {
      let num = (this.item.sale_num / this.item.total_num) * 100;
      if (num < 1 && num) {
        return 1;
      } else if (num > 99 && num < 100) {
        return 99;
      } else {
        return Math.round(num);
      }
    },
  },
  methods: {
    formBBD(val) {
      if (!val || val.indexOf("/") !== -1) return val;
      let date = val.split("-");
      return `${date[2]}/${date[1]}/${date[0]}`;
    },
    showWish(goods) {
      if (store.state.isLogin) {
        if (goods.is_favorite || this.is_favorite || this.isWish) {
          this.$json
            .delete(`favorite/product/${goods.product_id}`)
            .then((res) => {
              this.$message.success(res.msg);
              goods.is_favorite = false;
              this.is_favorite = false;
              // 收藏商品页面需要刷新一下数据
              this.$emit("update-wish");
              // 更新本地收藏数据
              store.commit("UPDATA_FAVORITE_LIST", {
                fav_type: 1,
                fav_content: goods.product_id,
              });
            });
        } else {
          this.$json
            .post("favorite", {
              type: 1,
              content: goods.product_id,
            })
            .then((res) => {
              this.$message.success(res.msg);
              goods.is_favorite = true;
              goods.favorite_id = res.data;
              this.is_favorite = true;
              store.commit("UPDATA_FAVORITE_LIST", {
                symbol: 1,
                id: res.data,
                fav_type: 1,
                fav_content: goods.product_id,
              });
            });
        }
      } else {
        store.commit("OPEN_LOGIN", document.querySelector("#sidebar"));
      }
    },
    showCart(item) {
      this.dialogVisible = true;
      this.goodsDetail = item;
    },
    dialogVisibleShow($event) {
      this.dialogVisible = $event;
    },
    input(event) {
      this.goodsDetail = {};
    },
  },
};
</script>
  
  <style lang="scss">
@import "../../sass/main.scss";
@import "../../sass/_variables";
.fleaxbksg {
  display: flex;
  align-items: baseline;
}
.activity {
  position: absolute;
  left: 8px;
  top: 5px;
  font-size: 0.4615rem;
  font-weight: 500;
  color: #fff;
  padding: 2px 6px;
  border-radius: 2px;
  background: #ff5600;
  z-index: 1;
}
.addIcon {
  width: 1.1538rem;
  height: 1.1538rem;
}
.goods-item {
  // margin-left: 0.3508rem;
  // width: 6.4615rem;
  background: #fff;
  padding: 0.3846rem 0.6538rem 0.7692rem 0.6538rem;
  box-sizing: border-box;
  margin-top: 0.7692rem;
  &:hover .goods-top .top .heart {
    opacity: 1;
  }
  .goods-top {
    position: relative;
    // padding: 20px;
    text-align: center;
    .top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-direction: row-reverse;
      margin-bottom: 0.1923rem;
      height: 1.5385rem;
      position: relative;
      z-index: 1;
      .left-top {
        font-size: 0.5385rem;
        padding: 0.3846rem;
        color: #fff;
        border-radius: 8px;
        span {
          color: #fff !important;
        }
      }
      .red {
        background: #f33026;
      }
      .blue {
        background: #97c8eb;
      }
      .heart {
        cursor: pointer;
        display: block;
        opacity: 0;
        width: 1.1538rem;
        height: 1.1538rem;
        transition: all 0.5s;
      }
    }
    .goods-img {
      display: block;
      color: #000;
      position: relative;
      margin-bottom: 5px;
      .poabs {
        position: absolute;
        bottom: 0px;
        left: 0px;
        width: 100%;
        padding: 0.0769rem 0;
        background: #ff7802;
        font-size: 0.4615rem;
        font-weight: 500;
        color: #fff;
      }

      .goods-image {
        // background: #fff0e5
        //   url("/images/new/ins-05.png?x-oss-process=image/resize,m_lfit,h_50,w_50&d=50x50")
        //   no-repeat center center;
        width: 6.9231rem;
        height: 6.9231rem;
        display: inline-block;
        transition: all 0.5s;
        &:hover {
          transform: scale(1.1, 1.1);
        }
        img {
          object-fit: contain !important;
        }
        // object-fit: cover;
      }
      .soldout {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
    .left-top-hot {
      background-color: #f33026 !important;
    }
    .best-befor {
      position: absolute;
      bottom: 0.3846rem;
      left: 50%;
      transform: translateX(-50%);
      padding: 0.1154rem 0.3846rem;
      color: #fff;
      border-radius: 6px;
      background: #b1b1b1;
      font-size: 0.5385rem;
      z-index: 1;
    }
    .classify {
      background: #97c8eb;
    }
  }
  .zkFlexs {
    display: flex;
    align-items: center;
    margin-top: 0.3846rem;
  }
  .mleft5 {
    margin-left: 0.1923rem;
  }

  .offzkou {
    font-size: 0.4615rem;
    font-weight: 500;
    color: #ff5600;
    padding: 3px 5px;
    background: #fff0e5;
    border-radius: 2px;
  }
  .spceas {
    font-size: 0.5385rem;
    font-weight: 500;
    color: #999;
    margin-top: 0.3846rem;
  }
  .goods-name {
    width: 5.6923rem;
    word-break: break-all;
    font-size: 0.5385rem;
    font-weight: 500;
    color: #333;
    overflow: hidden;
    -webkit-line-clamp: 2;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    height: 1.5538rem;
  }
  .goods-bottom {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    margin-top: 0.3846rem;
    .add-card {
      cursor: pointer;
      color: $main;
      font-size: 1.5385rem;
    }
    .current-price {
      color: #f33026;
      font-weight: bold;
    }
    .goods-price {
      .oldPrice {
        text-decoration: line-through;
        font-size: 0.4615rem;
        font-weight: 500;
        color: #999;
        margin-left: 0.1923rem;
      }
      .spec-price {
        color: #000;
        font-size: 0.6923rem;
        font-weight: bold;
        color: #ff7802;
        .original > span {
          font-weight: 600;
          font-size: 0.4615rem;
        }
        del {
          color: #545353;
          font-size: 0.6923rem;
          letter-spacing: -1;
        }
      }
      .external-price {
        color: #f33026;
        font-weight: bold;
        span {
          // font-weight: normal;
          font-size: 0.6923rem;
        }
      }
      .spec {
        color: #afb1b3;
        font-size: 0.5385rem;
      }
    }
  }
  .progress {
    display: flex;
    justify-content: space-between;
    font-size: 0.7384rem;
    gap: 0.3846rem;
    height: 1.8846rem;
    margin-top: 0.3076rem;
    .sale {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
    .purchase {
      cursor: pointer;
      padding: 0 0.3846rem;
      height: 1.8846rem;
      text-align: center;
      line-height: 1.8846rem;
      background-color: #f13d3d;
      color: #fff;
      border-radius: 0.3076rem;
      &.gray {
        background-color: #7f7f7f;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// resources/js/components/singleGoodsFour.vue